<template>
  <div>
      <b-button
          style="margin-top: 25px;"
          variant="primary"
          block
          @click="handleDownloadPDF"
         >
        Download PDF
      </b-button>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
export default {
  name: "Display_Export_PDF",
  components: {},
  created(){},
  mounted() {},
  props: {
    currIdx: {
      type: Number,
      required: false,
      default: 0
    },
    outputs:  {
      type: Array,
      required: false,
      default: ()=>{ return []}
    }
  },
  computed: {
    canSend(){
      //check validity
      return this.emailAddress && this.emailAddress.length > 0;
    }
  },
  methods: {
    handleDownloadPDF(){
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: [8.5, 10]
      });

      let bodyText = this.generateBodyText();
      doc.text(bodyText, 1, 1);
      doc.save("TheWords.pdf");
    },
    generateBodyText(){
      let text="";
      if(!this.isEntireBook){
        //The Word
        let theWords = this.outputs[this.currIdx];
        if (theWords) {
          text = theWords.encouraging_words ? `THE WORDS \n${theWords.encouraging_words}` : "";
          text += theWords.scriptures ? this.generateTextScriptures(theWords.scriptures) : "";
          text += theWords.action_items ? this.generateTextActionItems(theWords.action_items) : "";
          text += theWords.parting_words ? `\n\n ${theWords.parting_words}` : "";
        }
      }
      return text;
    },
    generateTextScriptures(scriptures){
      let scriptureText = "\n\nSCRIPTURES\n";
      if(scriptures && Array.isArray(scriptures)){
       scriptures.forEach((aScripture)=>{
         scriptureText+=`${aScripture.text} - ${aScripture.book_chapter_vers ? aScripture.book_chapter_vers :'KJV' }\n`;
       })
      }
      return scriptureText;
    },
    generateTextActionItems(actionItems){
      let actionItemsText = "\n\nACTION ITEMS \n";
      if(actionItems && Array.isArray(actionItems)){
        actionItems.forEach((anActionItem)=>{
          actionItemsText+=`[] ${anActionItem}\n`;
        })
      }
      return actionItemsText;
    },
    handleShowUserNotification(message) {
      this.$store.dispatch("user/showNotification", {
        title: message.title,
        description: message.description,
        variant: message.variant
      });
    },
  },
  data() {
    return {
      status:null,
      emailAddress:null,
      isEntireBook: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
